import { Component } from "react";
import { Router, applyRouterMiddleware } from "react-router";
import { useScroll } from "react-router-scroll";
import { hot } from "react-hot-loader";

import AppRoutes from "./app-routes.jsx";
import { history, getIframePageInfoOnce } from "./util";
import tracking from "./tracking";

// Note: window.parentIFrame is set when the site is being used in embed mode.
// We use this to preserve the scroll position in the parent.

const SCROLL_TIMEOUT = 50;
export const SCROLL_UPDATE_INTERVAL = 300;

export function updateSavedScrollForLocation(location, cb) {
  getIframePageInfoOnce(({ scrollTop }) => {
    try {
      window.sessionStorage.setItem(`@@Scroll/${location.key}`, scrollTop);
    } catch (e) {
      // fall through, session storage blocked
    }
    cb && cb();
  });
}

const scrollMiddleware = useScroll(function(
  prevRouterProps,
  { routes, location }
) {
  if (
    location.state &&
    location.state.ignoreScrollBehavior &&
    location.action !== "POP"
  ) {
    // Ignore ignoreScrollBehavior for a "back" action (i.e. going back always restores scroll)
    return false;
  }

  if (
    routes.some(route => route.ignoreScrollBehavior) ||
    (location.state && location.state.ignoreScrollBehavior)
  ) {
    return false;
  }

  if (routes.some(route => route.scrollToTop)) {
    if (window.parentIFrame) {
      setTimeout(
        () => window.parentIFrame.scrollToOffset(0, 0),
        SCROLL_TIMEOUT
      );
    }
    return [0, 0];
  }

  if (
    (routes.some(route => route.scrollPastBanner) ||
      (location.state && location.state.ignoreScrollBehavior)) &&
    (location.action === "PUSH" ||
      (location.action === "REPLACE" &&
        location.state &&
        location.state.replacedFromPush))
  ) {
    const banner = document.getElementById("Eventive--banner"),
      yOffset = banner
        ? banner.clientHeight +
          (window.TENANT.always_show_splash_banner ? 0 : 50)
        : 0;

    if (window.parentIFrame) {
      setTimeout(
        () => window.parentIFrame.scrollToOffset(0, yOffset),
        SCROLL_TIMEOUT
      );
    }

    return [0, yOffset];
  }

  if (window.parentIFrame) {
    try {
      let parentScrollPos =
        +window.sessionStorage.getItem(`@@Scroll/${location.key}`) || 0;
      if (parentScrollPos) {
        window.sessionStorage.removeItem(`@@Scroll/${location.key}`);
        setTimeout(
          () => window.parentIFrame.scrollTo(0, parentScrollPos),
          SCROLL_TIMEOUT
        );
      } else {
        setTimeout(
          () => window.parentIFrame.scrollToOffset(0, 0),
          SCROLL_TIMEOUT
        );
      }
    } catch (e) {
      // fall through, session storage blocked
    }
  }

  return true;
});

class AppRoot extends Component {
  componentDidMount() {
    history.listen((location, action) => {
      setTimeout(() => {
        // Record history event, with some delay (to allow document title to update)
        tracking.recordEvent("pageviews", {});
      }, 100);
    });

    // Record initial page view
    tracking.recordEvent("pageviews", { first_hit: true });

    // If this is the initial page load and we're trying to load the "login?next=back",
    // strip the next=back to ensure we don't accidentally paginate away from the site.
    let location = history.getCurrentLocation();
    if (location.pathname === "/login" && location.search === "?next=back") {
      history.replace("/login");
    }
  }

  render() {
    return (
      <Router
        routes={AppRoutes}
        history={history}
        render={applyRouterMiddleware(scrollMiddleware)}
      />
    );
  }
}

export default hot(module)(AppRoot);



// WEBPACK FOOTER //
// ./src/app/app-root.jsx